import { ChangeEvent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useCreateOrUpdateMwstSatzMutation, useDeleteMwstSatzMutation, useGetMwstSatzListeMutation } from '../../../api/StammdatenAPI';
import { IMwstSatz } from '../../../types/Types';
import { formatToEuroDate, formatToStringISODate } from '../../../util/DateUtils';
import Footer from '../../footer/Footer';
import LandingpageHeader from '../../header/LandingpageHeader';

export default function MwstSatzMain() {

  //const dispatch = useDispatch<AppDispatch>();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [daten, setDaten] = useState<IMwstSatz>({ uid: '', satz: 0, gueltigAb: new Date() });
  const [getListe] = useGetMwstSatzListeMutation();
  const [deleteApi] = useDeleteMwstSatzMutation();
  const [createOrUpdateDienstleistungAPI] = useCreateOrUpdateMwstSatzMutation();
  const [liste, setListe] = useState<IMwstSatz[]>([]);

  const lade = () => {

    getListe().unwrap()
      .then((data) => setListe(data));

  }

  const deleteSatz = (e: string) => {
    deleteApi(e).unwrap()
      .then(() => lade());
  }

  const handleSubmit = (e: { preventDefault: () => void; target: any; }) => {
    e.preventDefault();

    if (daten) {
      createOrUpdateDienstleistungAPI(daten)
        .then(lade)
        .catch((ee) => console.log(ee))
    }

  }

  const changeit = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDaten((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value
    }));
  }

  const changedate = (e: ChangeEvent<HTMLInputElement>) => {
    setDaten((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value
    }));
  }

  useEffect(() => {
    lade();
  }, []);

  return (
    <>
      <div>

        <LandingpageHeader />

        <div style={{ padding: "20px" }}>

          <div className="container">
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <button
                onClick={() => {
                  navigate({
                    pathname: "/",
                    search: ""
                  });
                }}

                style={{ marginBottom: "20px" }}
                className=' btn btn-outline-primary'
              >
                <i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
              </button>
            </div>

            <h3>MwstSatz</h3>
            <form onSubmit={handleSubmit} >

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", padding: "40px", backgroundColor: "lightgrey" }}>
                <div >
                  <div>Satz in Prozent</div>
                  <div><input type="text" name="satz" value={daten?.satz} onChange={changeit} /></div>
                </div>

                <div >
                  <div>Gueltig Ab</div>
                  <div><input type="date" name="gueltigAb" value={formatToStringISODate(daten?.gueltigAb)} onChange={changedate} /></div>
                </div>

                <div >
                  <div>&nbsp;</div>
                  <div><button type="submit" className="btn btn-primary"><i className="bi bi-plus"></i> {t('deTranslation.misc.neuanlage')}</button></div>
                </div>
              </div>
            </form>
            <p>
              Anzahl {liste.length}
            </p>

            <div style={{ display: "grid", fontWeight: "bold", gridTemplateColumns: "2fr 2fr 1fr", gap: "10px", alignItems: "center", padding: "10px", marginTop: "10px", border: "1px solid #ccc" }}>
              <div>Gültig Ab</div>
              <div>Satz</div>
              <div style={{ textAlign: "end" }}>
                Option
              </div>
            </div>

            {liste.map((e, index) => <>
              <div key={index} style={{ display: "grid", gridTemplateColumns: "2fr 2fr 1fr", gap: "10px", alignItems: "center", padding: "10px", marginTop: "10px", border: "1px solid #ccc" }}>
                <div>{formatToEuroDate(e.gueltigAb)}</div>
                <div>{e.satz}</div>
                <div style={{ textAlign: "end" }}>
                  <button className='btn btn-danger' onClick={() => deleteSatz(e.uid)}><i className="bi bi-trash"></i></button>
                </div>
              </div>
            </>)}


        </div>
      </div>
    </div >
      <Footer />
    </>
  );
}
